
import {Options, Vue} from "vue-class-component";
import {Exhibitor} from "@/entities/Exhibitor";
import {isDefined} from "@/utils";
import Stand from "@/entities/Stand";
import {Theme} from '@/entities/Theme';
import {ThemeTree, ThemeTreeNode} from '@/entities/ThemeTree';
import ThemeRoot from '@/components/ThemeRoot.vue';
import ThemeDisplay from '@/components/ThemeDisplay.vue';


@Options({
  components: {ThemeDisplay, ThemeRoot},
  props: {
    themes: {
      default: [],
      required: true,
      type: Array
    },
    openStandDialog: {
      required: true,
      type: Function
    }
  }
})
export default class ExhibitorDetailDialog extends Vue {

  private exhibitor: Exhibitor;
  private themes: Theme[];
  public isOpen: boolean = false;
  private openStandDialog: Function;
  private themeTrees: ThemeTree[];

  constructor(props) {
    super(props);
  }

  public openDialog(exhibitor: Exhibitor): void {
    this.exhibitor = exhibitor;
    this.buildThemeTreeForExhibitor();
    this.addClickListener();
    this.isOpen = true;
  }

  private buildThemeTreeForExhibitor() {
    const roots: Theme[] = this.themes.filter(t => t.parentId === '-1' || t.parentId === 'ROOT');
    Theme.sort(roots);
    const themeTrees: ThemeTree[] = [];
    for (const root of roots) {
      const rootChildren = this.themes.filter(t => t.parentId === root.id);
      Theme.sort(rootChildren);
      const themeTree = new ThemeTree(new ThemeTreeNode(root, rootChildren.map(t => new ThemeTreeNode(t, []))));
      this.traverseTree(themeTree.root);
      themeTrees.push(themeTree);
    }
    this.themeTrees = themeTrees;
  }

  public traverseTree(root: ThemeTreeNode) {
    for (const node of root.children) {
      const children = this.themes.filter(t => t.parentId === node.theme.id);
      if (children.length > 0) {
        node.children = children.map(c => new ThemeTreeNode(c, []));
        this.traverseTree(node);
        for (const n of node.children) {
          this.traverseTree(n);
        }
      }
    }
  }

  public closeDialog(): void {
    this.removeClickListener();
    this.isOpen = false;
  }

  private callOpenStandDialog(stand: Stand, event: Event): void {
    this.removeClickListener();
    this.openStandDialog(stand, event)
  }

  private onClick(event) {
    if (isDefined(this.$refs.container) && this.isOpen) {
      const container = this.$refs.container as any;
      if (isDefined(container)) {
        if (!container.contains(event.target)) {
          this.closeDialog();
        }
      }
    }
  }

  public addClickListener() {
    window.addEventListener('click', this.onClick);
  }

  private removeClickListener() {
    window.removeEventListener('click', this.onClick);
  }

  public getIconBySocialType(type: string): string {
    if (isDefined(type)) {
      switch (type) {
        case 'I':
          return 'fa-instagram';
        case 'F' :
          return 'fa-facebook'
        case 'L' :
          return 'fa-linkedin'
        case 'T' :
          return 'fa-x-twitter'
        case 'X' :
          return 'fa-xing'
        case 'O':
          return 'fa-tiktok'
        case 'Y':
           return 'fa-youtube'
      }
    }
  }

}
